// extracted by mini-css-extract-plugin
export default {"description":"_4ExN1FWBPKHKwPLHjksvoA"};